
export const _is = {
    methods: {
        _is(message, type){

            let messageTags = (message && message.tags && message.tags.length) ? message.tags : [];
  
            if(type == 'deleted'){
              if((messageTags.indexOf(this.getEnumaratedTags.Deleted._id) !== -1)){
                return true
              }else{
                return false
              } 
            }
  
            if(type == 'hidden'){
              if((messageTags.indexOf(this.getEnumaratedTags.Hidden._id) !== -1)){
                return true
              }else{
                return false
              } 
            }
  
            if(type == 'directMessage'){
              if((messageTags.indexOf(this.getEnumaratedTags.DirectMessage._id) !== -1)){
                return true
              }else{
                return false
              }             
            }
  
            if(type == 'mention'){
              if((messageTags.indexOf(this.getEnumaratedTags.Mention._id) !== -1)){
                return true
              }else{
                return false
              }             
            }
  
            if(type == 'ads'){
              if((messageTags.indexOf(this.getEnumaratedTags.AdsPost._id) !== -1)){
                return true
              }else{
                return false
              }             
            }

            if(type == 'review'){
              if((messageTags.indexOf(this.getEnumaratedTags.OneStar._id) !== -1 || messageTags.indexOf(this.getEnumaratedTags.TwoStar._id) !== -1 || messageTags.indexOf(this.getEnumaratedTags.ThreeStar._id) !== -1 || messageTags.indexOf(this.getEnumaratedTags.FourStar._id) !== -1 || messageTags.indexOf(this.getEnumaratedTags.FiveStar._id) !== -1 )){
                return true
              }else{
                return false
              }             
            }
          }
    }

}


// WEBPACK FOOTER //
// ./src/components/dashboard/mixins/_is.js